import React from 'react';
import type { ReceptionistDemoState } from '../../receptionist-dashboard/types';
import { useNow } from '../../receptionist-dashboard/utils';
import { IconButton } from '../IconButton/IconButton';
import { DashboardToggleGroup } from './shared/DashboardToggleGroup';

const DEMO_STATES = [
  { id: 'mature' as const, label: 'Today' },
  { id: 'trial' as const, label: 'Trial · Day 6' },
  { id: 'empty' as const, label: 'Just launched' },
];

export interface ReceptionistDashboardTopBarActionsProps {
  demoState: ReceptionistDemoState;
  onDemoStateChange: (state: ReceptionistDemoState) => void;
  onHelp?: () => void;
  onBell?: () => void;
}

export function ReceptionistDashboardTopBarActions({
  demoState,
  onDemoStateChange,
  onHelp,
  onBell,
}: ReceptionistDashboardTopBarActionsProps) {
  const time = useNow();

  return (
    <div className="flex shrink-0 flex-wrap items-center justify-end gap-2">
      <DashboardToggleGroup
        value={demoState}
        onChange={onDemoStateChange}
        options={DEMO_STATES}
      />

      <span className="inline-flex h-8 items-center gap-[7px] rounded-[9px] border border-[var(--ai-tint)] bg-[var(--ai-tint)] px-2.5">
        <span className="elva-live" />
        <span className="text-[11px] font-bold uppercase tracking-[0.04em] text-[var(--ai-3)]">Live</span>
        <span className="ml-px font-[var(--font-mono)] text-[10.5px] text-[var(--ink-3)]">{time}</span>
      </span>

      <IconButton
        icon="help"
        size={32}
        onClick={onHelp}
        label="Help"
        className="rounded-[9px] border-[var(--cream-2)] bg-[var(--surface-mute)] hover:bg-[var(--cream-1)]"
      />
      <div className="relative">
        <IconButton
          icon="bell"
          size={32}
          onClick={onBell}
          label="Notifications"
          className="rounded-[9px] border-[var(--cream-2)] bg-[var(--surface-mute)] hover:bg-[var(--cream-1)]"
        />
        <span className="absolute right-1.5 top-1.5 h-1.5 w-1.5 rounded-full bg-[var(--terracotta)] shadow-[0_0_0_2px_var(--surface-mute)]" />
      </div>
    </div>
  );
}
